var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 31.0175H12.5C5.26002 31.0175 2.16669 27.9242 2.16669 20.6842V12.6842C2.16669 5.44416 5.26002 2.35083 12.5 2.35083H20.5C27.74 2.35083 30.8334 5.44416 30.8334 12.6842V20.6842C30.8334 27.9242 27.74 31.0175 20.5 31.0175ZM12.5 4.35083C6.35335 4.35083 4.16669 6.5375 4.16669 12.6842V20.6842C4.16669 26.8308 6.35335 29.0175 12.5 29.0175H20.5C26.6467 29.0175 28.8334 26.8308 28.8334 20.6842V12.6842C28.8334 6.5375 26.6467 4.35083 20.5 4.35083H12.5Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.5642C16.2467 20.5642 15.9934 20.4708 15.7934 20.2708L11.0867 15.5642C10.7 15.1775 10.7 14.5375 11.0867 14.1508C11.4734 13.7642 12.1134 13.7642 12.5 14.1508L16.5 18.1508L20.5 14.1508C20.8867 13.7642 21.5267 13.7642 21.9134 14.1508C22.3 14.5375 22.3 15.1775 21.9134 15.5642L17.2067 20.2708C17.0067 20.4708 16.7534 20.5642 16.5 20.5642Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDown);
export default __webpack_public_path__ + "static/media/move-down.0113c2307b34a91fd174f9a3ec11015a.svg";
export { ForwardRef as ReactComponent };